import { render, staticRenderFns } from "./EDCompetency.vue?vue&type=template&id=d591914c"
import script from "./EDCompetency.vue?vue&type=script&lang=js"
export * from "./EDCompetency.vue?vue&type=script&lang=js"
import style0 from "./EDCompetency.vue?vue&type=style&index=0&id=d591914c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports